"use client";

import { useMemo } from "react";

// Runs identically during SSR and hydration so the decoded markup matches.
export function decodeJsonLdPayload(payload: string): string {
  const bytes = Uint8Array.from(atob(payload), (char) => char.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}

// Client component + base64 prop keep the schema out of the RSC flight payload, which Google parses as a second JSON-LD copy (vercel/next.js#66896).
export function JsonLdScript({ payload }: { payload: string }) {
  const json = useMemo(() => decodeJsonLdPayload(payload), [payload]);

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: json }}
    />
  );
}
